import React from 'react'
import TableData from './TableData';
// import DescriptionComponent from '../../commonComponents/DescriptionComponent'

import { connect } from 'react-redux';
import { getInitialData } from '../../../actions/index'
import { bindActionCreators } from 'redux';

var Select = require('react-select');

var moduleStyle = {
    width: '300px',
    margin: '20px auto'
};

var hStyle = {
    margin: '5% auto',
    textAlign: 'center'
}

var topStyle = {
    marginLeft: '-1px',
    marginTop: '21px'
};

var propertyType = null;
var labelShow = [];
var growthPeriod = [];
var prevWord = null;
var reponseData = null;
var property, propMulti;

class ReportComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = props;
        if(!props.selectedMetric)
            this.props.getInitialData(props.dataSet, props.chartCat, props.authData);
    }
    handleChange(e, type) {
        if (e == 'property') {
            propertyType = '';
            var sample = '';
            var condition = type == null ? true : (type.length == 0 ? true : false);
            if (!condition) {
                // if (type.length)
                //     propMulti = type[type.length - 1].type == 'propertyLabel' ? false : true;
                // if (!propMulti) {
                //     if (type.length) {
                //         sample = type[type.length - 1].value;
                //         type = type[type.length - 1];
                //     }
                //     else {
                //         sample = type.value;
                //         type = type;
                //     }
                // }
                // else {
                type.forEach(function (data, index) {
                    if (index != 0)
                        sample += "," + data.value;
                    else sample += data.value;
                })
                // }
            } else sample = 'null';
            var disableMetric = sample ? (sample.split(';')[1] ? ((sample.split(';')[1]).toLowerCase() == 'security' ? false : true) : true) : true;
            if (disableMetric)
                disableMetric = sample ? (sample.split(';')[0] ? ((sample.split(';')[0]).toLowerCase() == 'security' ? false : true) : true) : true;
            if (disableMetric) {
                this.state.Metric.forEach(function (data, index) {
                    if (data.value == 'Price' || data.value == 'minPrice' || data.value == 'maxPrice' || data.value == 'avgPrice' || data.value == 'open')
                        data.disabled = true;
                });
                if (this.state.metricValue == 'Price' || this.state.metricValue == 'minPrice' || this.state.metricValue == 'maxPrice' || this.state.metricValue == 'avgPrice' || this.state.metricValue == 'open') {
                    this.state.metricValue = this.state.Metric[1].value;
                } else this.state.metricValue = this.state.metricValue;
            } else {
                this.state.Metric.forEach(function (data, index) {
                    if (data.value == 'Price')
                        data.disabled = false;
                });
            }
            if (condition) {
                type = {
                    label: 'Total',
                    value: 'all',
                    type: "propertyLabel"
                };
            }
            this.setState({
                property: sample,
                propertyDisp: type,
                Metric: this.state.Metric,
                metricValue: this.state.metricValue,
                point: null,
                metricRange: ''
            });
            handleurl(sample, null, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        } else if (e == 'propertyValue') {
            this.setState({
                SelectedCategoryValue: type,
                point: null,
                metricRange: ''
            });
            handleurl(this.state.property, type, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        } else if (e == 'metric') {
            var sampleValue = '';
            type.map(function (innerData, index) {
                if (index != 0)
                    sampleValue += "," + innerData.value;
                else sampleValue = innerData.value;
            })

            this.setState({
                selectedMetric: sampleValue,
                selectedMetricDisp: type,
                question: null,
                questionId: null,
                point: null,
                metricRange: ''
            });
            handleurl(this.state.property, null, sampleValue, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        } else if (e == 'metricDisp') {
            this.setState({
                selectedMetricDisp: type,
                point: null
            });
        } else if (e == 'breakup') {
            var sample = '';
            if (type != null) {
                type.forEach(function (data, index) {
                    if (index != 0)
                        sample += "," + data.value;
                    else sample += data.value;
                })
            } else sample = null;

            this.setState({
                SelectedBreakUp: sample,
                SelectedBreakUpDisp: type,
                question: null,
                questionId: null,
                point: null,
                metricRange: ''
            });
            handleurl(this.state.property, null, this.state.selectedMetric, sample, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        } else if (e == 'savedReport') {
            var link = type == null ? '/dashboard/report' : type.link;
            window.location.href = link;
        } else if (e == 'imetric') { //insightMetric
            this.setState({
                insightMetric: type,
                insightDate: null,
                insightPoint: null
            });
            handleurl(this.state.property, null, sampleValue, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        } else if (e == 'growth') {
            this.setState({
                periodComparison: type,
                question: null,
                questionId: '',
                metricRange: '',
                point: null
            });
            // when propertyvalue is updated then url of just propertyvalue changes other
            // remains same
            handleurl(this.state.property, null, this.state.selectedMetric, this.state.SelectedBreakUp, e, type, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, type);
        } else {
            var dropdownConfig = updatePeriodComparisonDropdown(this.state.periodComparison, e, type);
            growthPeriod = dropdownConfig['growthPeriod'];
            var periodComparison = dropdownConfig['periodComparison'];
            this.setState({
                startDate: e,
                endDate: type,
                point: null,
                metricRange: ''
            });
            handleurl(this.state.property, null, this.state.selectedMetric, this.state.SelectedBreakUp, e, type, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, this.state.transpose, periodComparison);
        }
        if (e != 'metricDisp') {
            this.setState({
                question: null,
                questionId: null,
                drill: null,
                point: null
            });
        }
    }
    changeChart(e, type) {
        if (e == 'time') {
            // Set transpose to false
            var tempStartDate = moment(this.state.startDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var tempEndDate = moment(this.state.endDate, "YYYY-MM-DD").format('YYYY-MM-DD');
            var dateDiff = moment(tempStartDate, 'YYYY-MM-DD').diff(moment(tempEndDate, 'YYYY-MM-DD'), 'days');
            if (type == "Day" && dateDiff < -365) {
                jQuery('.dateText').text(moment(this.state.startDate).format(dateFormatCalendar1) + ' - ' + moment(this.state.endDate).format(dateFormatCalendar2));
                alert("Day wise data can be viewed for one year only.");
                return null;
            }
            var transpose = type ? 'false' : this.state.transpose;
            metricGlobal = modifyMetricGlobal(metricGlobalAll, 'report', type);
            this.setState({
                period: type,
                insightDate: null,
                insightPoint: null,
                transpose: transpose,
                Metric: metricGlobal
            });
            handleurl(this.state.property, null, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, type, transpose, this.state.periodComparison);
        } else if (e == 'transpose') {
            var transpose = (this.state.transpose == 'false' || !this.state.transpose) ? 'true' : 'false';
            this.setState({
                transpose: transpose
            });
            handleurl(this.state.property, null, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, this.state.metricRange, this.state.period, transpose, this.state.periodComparison);
        }
    }
    modifySavedReport(data) {
        var finalReport = [];
        data.map(function (val, index) {
            var temp = [];
            var url = val['reportData'];
            var id = val['id'];
            var name = val['name'];
            var frequency = val['frequency'];
            if (getParametersFromString('reportId', url)) {
                url = url.replace('reportId=', 'reportId=' + id);
                url = url.replace('reportName=', 'reportName=' + encodeURIComponent(name));
                url = url.replace('reportFrequency=', 'reportFrequency=' + frequency);
            } else {
                url += '&reportId=' + id;
                url += '&reportName=' + name;
                url += '&reportFrequency=' + frequency;
            }
            temp['label'] = temp['value'] = name;
            temp['link'] = url;
            finalReport.push(temp);
        });
        return finalReport;
    }
    componentWillMount() {
        this.setState({...this.props});
        // this.handleUrlChange(this.state, 1);
    }
    componentWillReceiveProps(nextProps) {
        this.setState({...nextProps});
    }
    handleUrlChange(data, updateStatus) {
        var that = this;
        handleChange_function = this.handleChange;
        jQuery.ajax({
            type: 'Get',
            data: 'property=' + encodeURIComponent(decodeURIComponent(data.property)) + "&filter=" + encodeURIComponent(decodeURIComponent(data.SelectedBreakUp)),
            url: '/dashboard/report/getmetric',
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                var reportData = jQuery.parseJSON(response.savedReport);
                var reportList = that.modifySavedReport(jQuery.parseJSON(reportData.typeData));
                var response = jQuery.parseJSON(response.data);
                main_property_array = jQuery.parseJSON(response.property);
                metricGlobal = jQuery.parseJSON(response.metric);
                metricGlobalAll = metricGlobal;
                metricGlobal = modifyMetricGlobal(metricGlobal, 'report', that.props.data.period);
                dashboard_options = response.dashboard;
                metricFunction = jQuery.parseJSON(response.metricFunction);
                metricPossibleCombinations = createCombination(metricGlobal, metricFunction);
                var users = reportData.users;
                var sample = null,
                    propertyMain = null,
                    propertyNew = decodeURIComponent(data.property);
                if (decodeURIComponent(data.SelectedBreakUp) && decodeURIComponent(data.SelectedBreakUp) != 'undefined' && decodeURIComponent(data.SelectedBreakUp) != 'null')
                    sample = jQuery.parseJSON(reportData.filter);
                if (decodeURIComponent(data.property) && decodeURIComponent(data.property) != 'undefined' && decodeURIComponent(data.property) != 'null') {
                    propertyMain = jQuery.parseJSON(reportData.property);
                    propMulti = propertyMain[propertyMain.length - 1].type == 'propertyLabel' ? false : true;
                    if (!propMulti) {
                        if (propertyMain.length > 2)
                            propertyMain = propertyMain[0];
                    }
                } else {
                    if (updateStatus && decodeURIComponent(data.property) != 'null' && decodeURIComponent(that.state.question) == "") {
                        propertyMain = jQuery.parseJSON(reportData.property);
                        propertyNew = jQuery.parseJSON(reportData.property)[0].value;
                        selectedMetric = jQuery.parseJSON(reportData.chartValues)[0].metrics;
                        propMulti = false;
                    } else {
                        propertyMain = {
                            label: 'Total',
                            value: 'all',
                            type: "propertyLabel"
                        };
                        propertyNew = 'null';
                        propMulti = false;
                    }
                }
                var selectedMetric = decodeURIComponent(data.selectedMetric) == '' || decodeURIComponent(data.selectedMetric) == 'null' ? jQuery.parseJSON(reportData.chartValues)[0].metrics : decodeURIComponent(data.selectedMetric);
                var selectedMetricTemp = selectedMetric;
                var selectedMetricDisp = [];
                selectedMetricDisp = metricDataToDisp(metricGlobal, metricFunction, selectedMetricTemp);
                var metricRange = that.props && that.props.data ? that.props.data.metricRange : '';
                if (that.refs)
                    that.refs.sidebarInsightRef.closeSidebarAndOpenFilter('close');
                property_current_index = null;
                main_property_array.map(function (property, index) {
                    if (property.value == propertyNew) {
                        property_current_index = index;
                    }
                })
                var localGrowthPeriod = getGrowthPeriod(startDate, endDate);
                var calculatedGrowthPeriod = localGrowthPeriod[1];
                growthPeriod = localGrowthPeriod[0];
                var newPeriodComparison = '0';
                if (calculatedGrowthPeriod <= data.periodComparison) // if calculated periodComparison is same as set by user in db then set that
                    newPeriodComparison = data.periodComparison;
                data.periodComparison = newPeriodComparison; // else if it's something else then set previous period. No smart periodComparison setting here
                that.setState({
                    Breakup: null,
                    SelectedBreakUpDisp: sample,
                    SelectedBreakUp: decodeURIComponent(data.SelectedBreakUp),
                    Metric: metricGlobal,
                    SelectedCategoryValue: null,
                    selectedMetric: selectedMetric,
                    selectedMetricDisp: selectedMetricDisp,
                    Category: null,
                    CategoryValue: null,
                    property: propertyNew,
                    propertyDisp: propertyMain,
                    updateChange: 1,
                    drill: null,
                    drillUp: null,
                    drillDown: null,
                    question: decodeURIComponent(data.question),
                    questionId: decodeURIComponent(data.questionId),
                    savedReportList: reportList,
                    users: users,
                    metricRange: metricRange,
                    sortOrder: decodeURIComponent(data.sortOrder),
                    limit: decodeURIComponent(data.limit),
                    insightType: decodeURIComponent(data.insightType),
                    insightMetric: decodeURIComponent(data.insightMetric),
                    reportId: decodeURIComponent(data.reportId),
                    reportName: decodeURIComponent(data.reportName),
                    reportFrequency: decodeURIComponent(data.reportFrequency),
                    startDate: moment(decodeURIComponent(data.startDate), dateFormatToSend1).isValid() ? decodeURIComponent(data.startDate) : minDateCalendar,
                    endDate: moment(decodeURIComponent(data.endDate), dateFormatToSend2).isValid() ? decodeURIComponent(data.endDate) : maxDateCalendar,
                    period: data.period ? decodeURIComponent(data.period) : '',
                    point: null,
                    transpose: decodeURIComponent(data.transpose),
                    periodComparison: data.periodComparison,
                });
                propertyMain = propertyNew;
                if (updateStatus) { //when initial load then only set the url else back handles everything
                    handleurl(propertyNew, null, selectedMetric, decodeURIComponent(data.SelectedBreakUp), moment(decodeURIComponent(data.startDate), dateFormatToSend1).isValid() ? decodeURIComponent(data.startDate) : minDateCalendar, moment(decodeURIComponent(data.endDate), dateFormatToSend2).isValid() ? decodeURIComponent(data.endDate) : maxDateCalendar, decodeURIComponent(data.drill), decodeURIComponent(data.sortOrder), decodeURIComponent(data.limit), decodeURIComponent(data.insightType), decodeURIComponent(data.insightMetric), decodeURIComponent(data.reportId), decodeURIComponent(data.reportName), decodeURIComponent(data.reportFrequency), metricRange, decodeURIComponent(data.period), decodeURIComponent(data.transpose), decodeURIComponent(data.periodComparison));
                }
            }
        });
    }
    updateMetricRange(metricRange) {
        this.setState({
            metricRange: metricRange
        });
        handleurl(this.state.property, null, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, this.state.reportId, this.state.reportName, this.state.reportFrequency, metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
    }
    // Commented by Anurag. This will be used when we want description to be independent of Insight
    // enablePageDescription(enableDescription) {
    //     // Anurag Comment: Pass insightPoint and insightDate when we want description independent of Insight
    //     enablePageDescription({enableDescription: enableDescription});
    //     // this.setState({
    //     //     enableDescription: enableDescription,
    //     //     insightDate: null,
    //     //     insightPoint: null
    //     // });
    // }
    componentDidUpdate() {
        var $frequency = document.getElementById('frequencyId');
        if ($frequency) {
            var reportFrequency = this.state.reportFrequency;
            $frequency.selectedIndex = reportFrequency ? reportFrequency : 'None';
        }
        // mobile_width,filter_desktop_width,main_content_div_filter,filter_mobile_width
        if (filter_enabled === "1") {
            if (jQuery(window).width() >= mobile_width) {
                openSidebar('FilterDiv', filter_desktop_width);
                document.getElementById("main-content").style.marginRight = main_content_div_filter;
            } else openSidebar('FilterDiv', filter_mobile_width);
        }
        filter_enabled = 3;
    }
    updateSavedReportParams() {
        handleurl(this.state.property, this.state.SelectedCategoryValue, this.state.selectedMetric, this.state.SelectedBreakUp, this.state.startDate, this.state.endDate, this.state.drill, this.state.sortOrder, this.state.limit, this.state.insightType, this.state.insightMetric, '', '', '', this.state.metricRange, this.state.period, this.state.transpose, this.state.periodComparison);
        this.setState({
            reportId: '',
            reportName: '',
            reportFrequency: ''
        });
    }
    pinHandle(title, dashboard_id, dashboard_value, dashboard_time_range) {
        var data = {};
        if (dashboard_time_range) {
            dashboard_time_range = dashboard_time_range.split("_");
            data.startDate = "{'date_method':'endDate','count':" + (dashboard_time_range[0] - 1) + ",'date_format':'" + dashboard_time_range[1] + "'}";
            data.endDate = "{'date_method':'endDate'}";
        } else {
            data.startDate = this.state.startDate;
            data.endDate = this.state.endDate;
        }
        data.category = this.state.property;
        data.selectedMetric = this.state.selectedMetric;
        data.drill = this.state.drill;
        data.drillHandle = null;
        data.metric = this.state.metricValue;
        data.breakUp = this.state.SelectedBreakUp;
        data.metrics = this.state.Metric;
        data.sortOrder = this.state.sortOrder;
        data.limit = this.state.limit;
        data.insightType = this.state.insightType;
        data.insightMetric = this.state.insightMetric;
        data.insightPoint = this.state.point;
        data.handleChange = null;
        data.selectedMetricDisp = this.state.selectedMetricDisp;
        data.startDateDisp = this.state.startDateDisp;
        data.endDateDisp = this.state.endDateDisp;
        data.selectedMetricDisp = this.state.selectedMetricDisp;
        data.metricRange = this.state.metricRange;
        data.metricText = labelShow.metricText;
        data.propertyText = labelShow.propertyText;
        data.breakupText = labelShow.breakupText;
        data.includeText = labelShow.includeText;
        data.excludeText = labelShow.excludeText;
        data.period = this.state.period;
        data.transpose = this.state.transpose;
        data.periodComparison = this.state.periodComparison;

        var fd = new FormData();
        fd.append('parameter', JSON.stringify(data));
        fd.append('componentType', 'Report');
        fd.append('pin_title', title);
        fd.append('pin_value', dashboard_value);
        fd.append('pin_id', dashboard_id);
        fd = encodePostBody(fd)
        jQuery.ajax({
            type: 'POST',
            url: '/dashboard/summary/pin',
            data: fd,
            contentType: false,
            processData: false,
            success: function (response) {
                response = decodeResponseBody(response)
                checkIfSessionTimedOut(response)
                alert('Successfully Pinned.');
            }.bind(this)
        });
    }
    render() {
        if (!this.props.selectedMetric) {
            return null;
        }
        var question;
        var questionId;
        var questionData;
        var users = null;
        if (this.props.granularity == "date" || this.props.granularity == "hour") {
            var TimeType = [{
                label: 'Aggregate',
                value: ''
            },
            {
                label: 'Year',
                value: 'Year'
            },
            {
                label: 'Quarter',
                value: 'Quarter'
            },
            {
                label: 'Month',
                value: 'Month'
            },
            {
                label: 'Week',
                value: 'Week'
            },
            {
                label: 'Day Name',
                value: 'Day Name'
            },
            {
                label: 'Day',
                value: 'Day'
            },
            {
                label: 'Hour',
                value: 'Hour'
            }
            ];
        } else if (this.props.granularity == "month") {
            var TimeType = [{
                label: 'Aggregate',
                value: ''
            },
            {
                label: 'Year',
                value: 'Year'
            },
            {
                label: 'Quarter',
                value: 'Quarter'
            },
            {
                label: 'Month',
                value: 'Month'
            }
            ];
        } else if (this.props.granularity == "year") {
            var TimeType = [{
                label: 'Aggregate',
                value: ''
            },
            {
                label: 'Year',
                value: 'Year'
            }
            ];
        }

        if (this.state.users)
            users = this.state.users;
        if (this.state.selectedMetricDisp)
            labelShow = getLabel(this.state.selectedMetricDisp, this.state.selectedMetric, this.state.propertyDisp, this.state.SelectedBreakUpDisp, this.state.insightType, this.state.insightMetric, this.state.includeDisp, this.state.excludeDisp);
        else
            labelShow = {
                'metricText': null,
                'propertyText': null,
                'breakupText': null
            };
            
        // var descriptionComponentVariabele = null
        
        // // if ((this.props.enableDescription || this.props.insightPoint || voiceQuestion == "1") && metricGlobal) {
        // if ((this.props.enableDescription || voiceQuestion == "1")) {
        //     let period = this.state.period;
        //     period = period ? period : (this.state.insightDate ? this.state.chartType : '');    // Set the period only when date is set
        //     descriptionComponentVariabele = <DescriptionComponent ref='descriptionRef' authData={this.props.authData} selectedMetric={decodeURIComponent(this.state.insightMetric ? this.state.insightMetric : this.state.selectedMetric)} chartCat={'Bar'} period={period} startDate={this.props.startDate} endDate={this.props.endDate} category={this.state.property} breakUp={this.state.SelectedBreakUp} include={this.props.include} exclude={this.props.exclude} metricRange = {this.state.metricRange} date={this.props.insightDate} point={this.props.insightPoint} enableDescription={this.props.enableDescription}/>            
        // }

        return (
            <div id="main-content">
                <div className='divSelect'>
                    <TableData
                        authData={this.props.authData} startDate={this.props.startDate} endDate={this.props.endDate} category={this.props.property} categoryValue={this.props.SelectedCategoryValue} selectedMetric={this.props.selectedMetric} breakUp={this.props.SelectedBreakUp} include={this.props.include} exclude={this.props.exclude} metrics={this.props.metricGlobal} drill={this.props.drill} drillHandle={drillHandleFunction} question={this.props.question} questionId={this.props.questionId} questionData={questionData} sortOrder={this.props.sortOrder} limit={this.props.limit} insightType={this.props.insightType} insightMetric={this.props.insightMetric} insightPoint={this.props.point} handleChange={this.handleChange} propertyDisp={this.props.propertyDisp} selectedMetricDisp={this.props.selectedMetricDisp} metricRange={this.props.metricRange} metricText={labelShow.metricText} propertyText={labelShow.propertyText} breakupText={labelShow.breakupText} includeText={labelShow.includeText} excludeText={labelShow.excludeText} period={this.props.period} transpose={this.props.transpose} periodComparison={this.props.periodComparison} index={1} multiDim={this.props.crosstab_flag === false ? false : true} kpiMonitoring={this.props.kpiMonitoring} kpiColumnConfig={this.props.kpiColumnConfig} globalFilters={this.props.globalFilters} sortMetric={this.props.sortMetric} cagrPoint={this.props.cagrPoint} dataset={this.props.dataSet} removeGlobalFilter={this.props?.removeGlobalFilter} prevStartDate = {this.props?.prevStartDate} prevEndDate = {this.props?.prevEndDate} ytdcagr = {this.props?.ytdcagr}

                    />
                        {/* {descriptionComponentVariabele} */}
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {

    var initial_data_from_url = {};
    initial_data_from_url = getURLDataHandle();

    initial_data_from_url.chartCat = "report";
    let finalObj = stateToPropsHandle(initial_data_from_url, state)
    return { ...finalObj, kpiColumnConfig: state.dataSet.kpiColumnConfig }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInitialData
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportComponent);